import { useTranslations } from 'next-intl';

import { type SalesChartOperationType } from '../../generated/graphql';

export function useFormatOperationType(): (operationPeriod: SalesChartOperationType) => string {
  return useTranslations('charts.filters.operationType.options');
}
